import { Box } from "@mui/material";

interface CustomStepperProps {
    className?: any;
    status: string;
    activity: string;
}

const CustomStepper = ({ className, status, activity }: CustomStepperProps) => {
    const progressColor = '#D1D1D1';
    
    const getIconByStatus = (activity: string) => {
        const iconColor = status === 'completed' ? '#26C365' : status === 'progress' ? progressColor : '#FF1943';

        if (!activity) {
            return null;
        }
        
        // Convert activity to lowercase for case-insensitive matching
        const activityLower = activity.toLowerCase();
        
        // Container Booking activities
        if (activityLower.includes('container order') || 
            activityLower.includes('container inspection') || 
            activityLower.includes('received bc 1.1') || 
            activityLower.includes('pengajuan peb') || 
            activityLower.includes('spfb') || 
            activityLower.includes('truck arrival at depo') || 
            activityLower.includes('truck depart from depo') ||
            activityLower.includes('fta application') ||
            activityLower.includes('bl date') ||
            activityLower.includes('npe') ||
            activityLower.includes('container booking')) {
            return <img
                alt="Container Booking"
                height={20}
                color={iconColor}
                src="/static/images/status/container-booking.svg"
            />;
        } 
        // Gate In Smelter activities
        else if (activityLower.includes('gate in smelter') || 
                 activityLower.includes('to area a') || 
                 activityLower.includes('driver has arrived') || 
                 activityLower.includes('truck container parking') ||
                 activityLower.includes('gate in smelter')) {
            return <img
                alt="Gate In Smelter"
                height={20}
                color={iconColor}
                src="/static/images/status/get-in-smelter.svg"
            />;
        } 
        // Start Loading activities
        else if (activityLower.includes('truck container start loading') || 
                 activityLower.includes('outgoing from') || 
                 activityLower.includes('preparation') ||
                 activityLower.includes('gate in smelter') ||
                 activityLower.includes('start loading')) {
            return <img
                alt="Start Loading"
                height={20}
                style={{ fill: '#000' }}
                color={iconColor}
                src="/static/images/status/start-loading.svg"
            />;
        } 
        // Finished Loading activities
        else if (activityLower.includes('seal + verification') || 
                 activityLower.includes('dropped') || 
                 activityLower.includes('the driver has picked up the cargo from') ||
                 activityLower.includes('gate out smelter') ||
                 activityLower.includes('finished loading')) {
            return <img
                alt="Finished Loading"
                height={20}
                color={iconColor}
                src="/static/images/status/finish-loading.svg"
            />;
        } 
        // Gate Out Smelter activities
        else if (activityLower.includes('gate out smelter')) {
            return <img
                alt="Gate Out Smelter"
                height={20}
                color={iconColor}
                src="/static/images/status/gate-out-smelter.svg"
            />;
        } 
        // Port Gate In activities
        else if (activityLower.includes('gate in port') || 
                 activityLower.includes('terminal gate in') ||
                 activityLower.includes('stevedoring') ||
                 activityLower.includes('port gate in')) {
            return <img
                alt="Port Gate In"
                height={20}
                color={iconColor}
                src="/static/images/status/port-gate-in.svg"
            />;
        } 
        // CY Check In activities
        else if (activityLower.includes('handed over at') || 
                 activityLower.includes('cy check in') || 
                 activityLower.includes('lift on container to vessel') ||
                 activityLower.includes('cy check in')) {
            return <img
                alt="CY Check In"
                height={20}
                color={iconColor}
                src="/static/images/status/cy-check-in.svg"
            />;
        } 
        // ATD POL activities
        else if (activityLower.includes('transit start date') || 
                 activityLower.includes('transit end date') || 
                 activityLower.includes('transhipment start date') || 
                 activityLower.includes('transhipment end date') || 
                 activityLower.includes('in transit at station') || 
                 activityLower.includes('in transit at') ||
                 activityLower.includes('ticket queue for loading') ||
                 activityLower.includes('atd pol')) {
            return <img
                alt="ATD POL"
                height={20}
                color={iconColor}
                src="/static/images/status/atd-pol.svg"
            />;
        } 
        // ATA POD activities
        else if (activityLower.includes('the cargo/container has been pickup at') || 
                 activityLower.includes('arrived at') || 
                 activityLower.includes('handed over') || 
                 activityLower.includes('handed over at the station') || 
                 activityLower.includes('taken over at') ||
                 activityLower.includes('ata pod')) {
            return <img
                alt="ATA POD"
                height={20}
                color={iconColor}
                src="/static/images/status/ata-pod.svg"
            />;
        } 
        else {
            // Default case - return null or a default icon
            return null;
        }
    };

    return (
        <div className={className} style={{
            width: '34px',
            height: '34px',
            color: 'white',
            display: 'flex',
            fontSize: '10px',
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: status === 'completed' ? '#26C365' : status === 'progress' ? progressColor : '#F9FAFB',
            boxShadow: '0px 2px 4px 0px rgba(4, 20, 124, 0.15)',

        }}>
            {status === 'completed' ? (
                <Box position="relative" display="inline-flex">
                    <Box
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        display="flex"
                        alignItems="center"
                        position="absolute"
                        justifyContent="center"
                        sx={{ color: 'black' }}
                    >
                        {getIconByStatus(activity)}
                    </Box>
                </Box>
            ) : status === 'progress' ? (
                <Box position="relative" display="inline-flex">
                    {/* <CircularProgress variant='determinate' value={100} size={34} color='warning' /> */}
                    <Box
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        display="flex"
                        alignItems="center"
                        position="absolute"
                        justifyContent="center"
                    >
                        {getIconByStatus(activity)}
                    </Box>
                </Box>
            ) : (
                getIconByStatus(activity)
            )}
        </div>
    );
};

export default CustomStepper;
